import { render, staticRenderFns } from "@/components/Layout/Menu/Administracion/Administracion_camiones/Crear_camiones/Crear_camiones.html?vue&type=template&id=059eced8&scoped=true&"
import script from "@/components/Layout/Menu/Administracion/Administracion_camiones/Crear_camiones/Crear_camiones.js?vue&type=script&lang=js&"
export * from "@/components/Layout/Menu/Administracion/Administracion_camiones/Crear_camiones/Crear_camiones.js?vue&type=script&lang=js&"
import style0 from "@/components/Layout/Menu/Administracion/Administracion_camiones/Crear_camiones/Crear_camiones.css?vue&type=style&index=0&id=059eced8&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "059eced8",
  null
  
)

export default component.exports